import { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';
import { INERT_EXEMPT_ATTR } from '../hooks/useInertBackground';
import { installToastTypeDefaults, TOAST_CONTAINER_PROPS } from './toastConfig';

// At module scope, so the typed defaults are in place before any toast fires.
installToastTypeDefaults();

/**
 * The app's one toast container (mounted by app/providers.tsx). Timing and
 * announcement by type: ./toastConfig.ts. The look: design-system/toasts.css.
 *
 * Portalled to its own child of <body>, marked exempt, so a toast raised
 * while a confirm is up is still announced: useInertBackground makes every
 * other <body> child (#root among them) inert and aria-hidden (b-011).
 */
export default function AppToastContainer() {
  const container = <ToastContainer {...TOAST_CONTAINER_PROPS} />;
  if (typeof document === 'undefined') return container;
  return createPortal(
    <div {...{ [INERT_EXEMPT_ATTR]: 'live-region' }}>{container}</div>,
    document.body,
  );
}
